const GET_SOCIETIES = "GET_SOCIETIES";
const GET_SOCIETIES_SUCCESS = "GET_SOCIETIES_SUCCESS";
const GET_SOCIETIES_FAIL = "GET_SOCIETIES_FAIL";
 
const UPDATE_SOCIETIES = "UPDATE_SOCIETIES";

const BASE_ENDPOINT = "/MasterData";
const initialValues = {
  loading: false,
  hasError: false,
  data:[]
};

const societies = (state = initialValues, action) => {
  switch (action.type) {
    case GET_SOCIETIES: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SOCIETIES_SUCCESS: {
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      };
    }

    case GET_SOCIETIES_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }
case UPDATE_SOCIETIES: {
      return {
        ...state,
        data:action.payload,
        loading: false,
      };
    }
    default: {
      return state;
    }
  }
};

export const getSocieties = () => {
  return {
    type: GET_SOCIETIES,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/Society",
      },
    },
  };
};

export const updateSocietiesSelected = (data) => {
  return {
    type: UPDATE_SOCIETIES,
    payload:data,    
  };
};

export default societies;
